
import { createClient } from '@/prismicio';
import Hero from '@/components/PreguntasFrecuentes/Hero';
import Footer from '@/components/Footer';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';
import useLangMenuBar from "@/hooks/useLangMenuBar";

const PreguntasFrecuentes = ({ locale, faqs, footer, menu }) => {
    

  return (
    <main className="relative site-max mx-auto preguntas-frecuentes">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Preguntas frecuentes',
          description:
            'Conocé nuestras preguntas frecuentes. Si tenés alguna otra dudas podés contactarte con nuestro equipo.',
          pathname: '/preguntas-frecuentes'
        })}
      />
      <Hero faqs={faqs} />
        <Footer footer={footer} locale={locale} />
    </main>
  );
};

export const getServerSideProps = async ({ previewData, req, locale: nextLocale, defaultLocale }) => {
  const client = createClient({ previewData });
  const { locale, dict } = await localeManager.getLocaleResources(req, {}, nextLocale || defaultLocale);

  try {
    const faqs = await client.getSingle('preguntas_frecuentes');
    return {
      props: {
        locale,
        footer: dict.home.footer,
        faqs: faqs.data.slices.map((s) => s.primary),
        menu: dict.menu
      }
    };
  } catch (error) {
    console.error('Error fetching FAQs:', error);
    return {
      props: {
        locale,
        footer: dict.home.footer,
        faqs: [],
        menu: dict.menu
      }
    };
  }
};

export default PreguntasFrecuentes;
